export const readBlobAsBase64 = async ({
  blob,
  errorPrefix,
}: {
  blob: Blob;
  errorPrefix?: string;
}): Promise<string> => {
  if (!blob) {
    throw new Error(`${errorPrefix ?? 'readBlobAsBase64'}: blob is required`);
  }

  const base64 = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error(`${errorPrefix ?? 'readBlobAsBase64'}: unexpected reader result`));
        return;
      }

      const commaIndex = result.indexOf(',');
      resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : result);
    };
    reader.onerror = () => {
      reject(new Error(`${errorPrefix ?? 'readBlobAsBase64'}: failed to read blob`));
    };
    reader.readAsDataURL(blob);
  });

  return base64;
};
